import { useQueryClient } from 'react-query';
import { CareCreditIntegrationV1 } from '@frontend/api-care-credit-integration';

export type UseCareCreditLocationProviderStatusProps = {
  locationId: string | undefined;
};
export type UseCareCreditLocationProviderOptions = {
  enabled?: boolean;
};
export const useCareCreditLocationProviderStatus = (
  { locationId }: UseCareCreditLocationProviderStatusProps,
  { enabled }: UseCareCreditLocationProviderOptions
) => {
  const queryClient = useQueryClient();

  const { data, isLoading, ...queryData } = CareCreditIntegrationV1.Queries.useGetMerchantConnectionQuery({
    request: {
      locationId,
    },
    options: {
      enabled: !!locationId && enabled,
      staleTime: Infinity,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      onError: () => {
        /**
         * The endpoint doesn't return a 200 "not found" response.
         * It just throws errors. When that happens, the cache doesn't get cleared.
         * So manually clearing it.
         */
        clearCache();
      },
    },
  });

  const clearCache = () => {
    queryClient.setQueryData(queryData.queryKey, undefined);
  };

  const { merchantNumber } = data ?? {};

  const isProviderConnected = !!merchantNumber;

  return {
    ...queryData,
    merchantState: data?.state,
    merchantNumber,
    isProviderConnected,
    isProviderLoading: isLoading,
  };
};
